<template>
  <div class="edit-active">
    <div class="box">
      <div class="box-template" v-for="(context,index) in contexts" :key="index">
        <div class="title">{{context.tittle}}</div>
        <div class="theme">
          会议主题:
          <span>{{context.title}}</span>
        </div>
        <div class="bodys">
          会议时间:
          <span>{{context.createtime | times}}</span>
        </div>
        <div class="submit">
          <button @click="goEdit(context)">编辑活动</button>
          <button class="delBtn" @click="deleteActi(context)">删除活动</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { deleteActivity } from '@/api/partyHomeApi'

export default {
  data() {
    return {
      contexts: [
        // {
        //   title: "三会一课【党组小会】",
        //   theme: "扫黑除恶",
        //   time: "扫黑除恶",
        //   bodys: "团结村党委成员全体",
        //   adress: "团结村党委办公室"
        // },
        // {
        //   title: "三会一课【党组小会】",
        //   theme: "扫黑除恶",
        //   time: "扫黑除恶",
        //   bodys: "团结村党委成员全体",
        //   adress: "团结村党委办公室"
        // }
      ],
      editStatus: 1
    };
  },
  methods: {
    deleteActi(context) {
      console.log('del: ', context)
      const params = {
        title: context.title,
        createtime: context.createtime,
        token: sessionStorage.getItem("token"),
      }
      console.log('params: ', params)
      this.$confirm('确认删除此活动?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteActivity(params).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getMsg()
          } else {
            this.$message({
              type: 'warning',
              message: res.msg
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    goEdit(context) {
      this.$router.push({
        path: "_createactive",
        query: { title: "编辑活动", ActiTitle: context.title, id: context.id, editStatus: this.editStatus }
      });
    },
    getMsg(){
      this.axios.post(
        '/api/Party/EditActivity',
        {title:sessionStorage.getItem('token')}
      ).then(e=>{
        console.log(e.data);
        if(e.data.code==0){
          this.contexts = e.data.msg
        }else{
          alert(e.data.msg)
        }
      }).catch(err=>{
        console.log(err);
        
      })
    }
  },
  mounted(){
    this.getMsg();
  }
};
</script>

<style lang="scss" scoped>
.edit-active {
  .box {
    .box-template {
      .submit {
        button {
          padding: 0.2rem 0.3rem;
          background-image: linear-gradient(250deg, #f9b94d 0%, #fdcb76 100%),
            linear-gradient(-70deg, #fb3f3f 0%, #fe5f5f 100%);
          background-blend-mode: normal, normal;
          border-radius: 0.04rem;
          border: 0;
          color: #fff;
          font-size: 0.26rem;
        }
        .delBtn {
          background-image: linear-gradient(250deg, #f97e4d 0%, #fd8676 100%),
            linear-gradient(-70deg, #fb3f3f 0%, #fe5f5f 100%);
            margin-left: 0.5rem;
        }
      }
      .title {
        color: #000;
      }
      div {
        span {
          color: #000;
        }
        padding: 0.2rem 0.3rem;
        color: #999999;
      }
      width: 80%;
      margin: 0.3rem auto;
      border-top: 0.16rem solid #f9b94d;
      border-radius: 0.08rem;
      box-shadow: 0px 0.06rem 0.06rem 0px rgba(0, 0, 0, 0.06);
    }
  }
  background: #fff;
  min-height: 100vh;
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>